import axios from "axios";
import { Form, Modal, Button } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";
import useAuth from "../../hooks/useAuth";
import { Base_URL } from "../../helpers/constants";

function AddUnitModal({ open, onClose, vendorId }) {
  const { auth } = useAuth();
  if (!open) return null;

  const token = auth.accessToken;

  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

  const schema = yup.object().shape({
    name: yup.string().required(),
    www: yup.string().url().required(),
    logoUrl: yup.string().url(),
    vendorid: yup.string(),
  });

  return (
    <div>
      <div>
        <Modal show={open} onHide={onClose} role="dialog">
          <Formik
            validationSchema={schema}
            onSubmit={(data) => {
              axios({
                method: "POST",
                url: `${Base_URL}addProfile`,
                data: data,
              })
                .then(function (res) {
                  console.log(res);
                  alert("Successfully addeed profile!");
                  onClose();
                })
                .catch(function (res) {
                  console.log(res);
                });
            }}
            initialValues={{
              name: "",
              www: "",
              logoUrl: "",
              vendorId: vendorId,
            }}
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Dodajanje podjetja</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="validationFormikName">
                    <Form.Label for="nameInput">Naziv</Form.Label>
                    <Form.Control
                      type={"text"}
                      name={"name"}
                      id={"nameInput"}
                      placeholder={"Vnesi naziv"}
                      value={values.name}
                      className="form-control"
                      onChange={handleChange}
                      isValid={touched.name && !errors.name}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="validationFormikWWW">
                    <Form.Label for="wwwInput">Spletno mesto</Form.Label>
                    <Form.Control
                      type="url"
                      name="www"
                      id="wwwInput"
                      placeholder="Vnesi URL spletnega mesta"
                      value={values.www}
                      className="form-control"
                      onChange={handleChange}
                      isValid={touched.www && !errors.www}
                      isInvalid={!!errors.www}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.www}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="validationFormiklogoUrl">
                    <Form.Label for="logoInput">URL logotipa</Form.Label>
                    <Form.Control
                      type="url"
                      name="logoUrl"
                      id="logoInput"
                      placeholder="Vnesi URL logotipa"
                      value={values.logoUrl}
                      className="form-control"
                      onChange={handleChange}
                      isValid={touched.logoUrl && !errors.logoUrl}
                      isInvalid={!!errors.logoUrl}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.logoUrl}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="submit">Dodaj</Button>{" "}
                  <Button type="button" variant="secondary" onClick={onClose}>
                    Prekliči
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
      </div>
    </div>
  );
}

export default AddUnitModal;
